const portfolioItems = [
  {
    "id": "1",
    "title": "Clip Reel",
    "url": "https://vimeo.com/1156789046",
    "description": ""
  },
  {
    "id": "2",
    "title": "The True Meaning of Christmas | Jay Bennett",
    "url": "https://www.youtube.com/watch?v=qvDFMGeHPBM",
    "description": "I directed, produced and edited this music video for Jay Bennett, a London-based comedian."
  },
  {
    "id": "3",
    "title": "I Trained like My Tyson for 24 Hours | ReadyMoneyTyrieq",
    "url": "https://www.youtube.com/watch?v=c_ZRJtaitnQ",
    "description": "I shot, directed and edited this YouTube video for \"Ready Money\" Tyieq, a London-based champion boxer."
  },
  {
    "id": "4",
    "title": "Hometown Glory - The Crowning of A New Cruiserweight King In Front of 15,000 Fans! | Boxxer",
    "url": "https://www.youtube.com/watch?v=paumTDPcDCc&t=283s",
    "description": "I operated second camera for this promo on Boxxer, promoting Chris Billiam-Smith v. Mateusz Masternark"
  },
  {
    "id": "5",
    "title": "I Faked My Own Death | Like or Death | Channel 4 Documentaries",
    "url": "https://www.youtube.com/watch?v=atGfCkENCdw",
    "description": "I assisted on the edit for one episode of “Like or Death”, a digital Channel 4 series documenting digital influencers who perform death-defying stunts or create generally dangerous content."
  },
  {
    "id": "6",
    "title": "Four Strangers Have One LOVE ISLANDER In Common! Can They Guess WHO?! | It's Mutual | Channel 4.0",
    "url": "https://www.youtube.com/watch?v=l_BFYfAqy_0",
    "description": "I edited two episodes of “It’s Mutual”, a digital Channel 4 game show series featuring contestants trying to guess a mutual friend. I also graded both episodes."
  },
  {
    "id": "7",
    "title": "Can 4 Girls Guess Who They Rejected For A Cash Prize?! | It's Mutual | Channel 4.0",
    "url": "https://www.youtube.com/watch?v=AMsv7kCH39k",
    "description": "I edited two episodes of “It’s Mutual”, a digital Channel 4 game show series featuring contestants trying to guess a mutual friend. I also graded both episodes."
  },
  {
    "id": "8",
    "title": "Hometown Glory - The Crowning of A New Cruiserweight King In Front of 15,000 Fans! ",
    "url": "https://www.youtube.com/watch?v=paumTDPcDCc",
    "description": "I shot MIV for a video promoting a December 2023 boxing match between Chris Billiam-Smith and Mateusz Masternak. The interview was with Billiam-Smith, who as of November 2023 is the WBO cruiserweight champion."
  },
  {
    "id": "9",
    "title": "y Entire Face And Body Are Tattooed - Until Today | TRANSFORMED",
    "url": "https://www.youtube.com/watch?v=z4nIjm-iRaQ",
    "description": "I end-to-end edited and scripted this episode of “Transformed,” a Truly series that showcases people with unique and distinct styles undergoing a major makeover."
  },
  {
    "id": "10",
    "title": "I've Been Stretching My 76mm Earlobes Since I Was 14 | HOOKED ON THE LOOK",
    "url": "https://www.youtube.com/watch?v=vEhlRagjKq4",
    "description": "I end-to-end edited and scripted this episode of “Hooked on the Look”, a Truly series that showcases people with unique and distinct styles."
  },
  {
    "id": "11",
    "title": "Cosplay Saved My Life | SHAKE MY BEAUTY",
    "url": "https://www.youtube.com/watch?v=d-e3oxdL9vs",
    "description": "I end-to-end edited this episode of “Shake my Beauty”, a Truly series that showcases people with unique and distinct styles, but with a more makeup/glam style than Hooked on the Look."
  },
  {
    "id": "12",
    "title": "I'm 29 And Pregnant For The 9th Time | MY EXTRAORDINARY FAMILY",
    "url": "https://www.youtube.com/watch?v=-PnyeeRPVRI",
    "description": "I end-to-end edited and scripted this episode of “My Extraordinary Family”, a Truly series that showcases quirky or unconventional families."
  },
  {
    "id": "13",
    "title": "The Twin Sisters Who Share A Body | BORN DIFFERENT",
    "url": "https://www.youtube.com/watch?v=IanewtnOC0A",
    "description": "I end-to-end edited and scripted this episode of “Born Different”, a Truly series that spotlights differently-abled people."
  },
  {
    "id": "14",
    "title": "I Make ‘Spicy’ Content - What Will My Date Think? | DATING DIFFERENT",
    "url": "https://www.youtube.com/watch?v=bNuUymlmXno",
    "description": "I end-to-end edited and scripted this episode of “Dating Different”, a Truly dating/matchmaking series."
  },
  {
    "id": "15",
    "title": "A Night Of Partying Changed Our Lives Forever | LOVE DON'T JUDGE",
    "url": "https://www.youtube.com/watch?v=MMzEp4qlqp4",
    "description": "I end-to-end edited and scripted this episode of “Love Don’t Judge”, a Truly series spotlighting unconventional couples and relationships. "
  },
  {
    "id": "16",
    "title": "Disinformation and Democracy (Part I) | People and Power",
    "url": "https://www.youtube.com/watch?v=eZEz6Pc3Z24",
    "description": "I associate-produced this two-part Al Jazeera special, which investigated the dissemination of misinformation around the time of major elections in 2016, 2017 and 2018, with a focus on Donald Trump’s 2016 presidential victory. Responsibilities ranged from post production responsibilities like assisting on editing and scripting; securing shooting locations and sourcing b-roll."
  },
  {
    "id": "17",
    "title": "Disinformation and Democracy (Part II) | People and Power",
    "url": "https://www.youtube.com/watch?v=cuaRz7BOm1A",
    "description": "I associate-produced this two-part Al Jazeera special, which investigated the dissemination of misinformation around the time of major elections in 2016, 2017 and 2018, with a focus on Donald Trump’s 2016 presidential victory. Responsibilities ranged from post production responsibilities like assisting on editing and scripting; securing shooting locations and sourcing b-roll."
  },
  {
    "id": "18",
    "title": "King Size - Making No Sound",
    "url": "https://www.youtube.com/watch?v=JpTRNlBFmy0",
    "description": "I shot, produced, directed and edited this music video for London-based band, King Size."
  },
  {
    "id": "19",
    "title": "Dear Toxic Masculinity (explicit)",
    "url": "https://www.youtube.com/watch?v=IxSqmz9WnME",
    "description": "I shot, produced, gripped/lit, directed and edited this music video for London-based comedian, Tamar Broadbent. "
  }
];

export default portfolioItems;
